import { useSelector } from "react-redux";
import { Button, Col, Modal, Row, Table, Typography } from "antd";
import { FaCalculator, FaRegFileAlt } from "react-icons/fa";
import locale from 'antd/es/locale/pt_BR';

import { IUpdateSistema } from "./interfaces";
import { ISistemaContabil, ISolicitacaoAtivacao } from "../../../../../interfaces";
import { stateGlobal } from "../../../../../../../../interfaces/Global";

import { useGerenciarSistemaContabil } from "./useGerenciarSistemaContabil";
import CardInformacao from "../../../../../../components/CardInformacao";

export interface IGerenciarSistemaContabilProps {
    solicitacao: ISolicitacaoAtivacao;
    onUpdateSistema: (sistema: ISistemaContabil) => void;
    requestUpdateSistema: (data: IUpdateSistema) => Promise<ISistemaContabil | null>;
}

export const GerenciarSistemaContabil = ({
    solicitacao,
    onUpdateSistema,
    requestUpdateSistema,
}: IGerenciarSistemaContabilProps) => {

    const propsState = useSelector((state: stateGlobal) => state.global);

    const {
        modalDesvincularUserVisible,
        clickCancelModalAddConfig,
        loadingTableModal,
        dadosTabelaUsuariosModal,
        columnsModal,
        refContagemDoFiltroTabelaModal,
        onClickEditarSistemaContabil,
        rowSelectionModal,
        onClickSave,
        isSubmiting,
    } = useGerenciarSistemaContabil({ solicitacao, onUpdateSistema, requestUpdateSistema });

    return (
        <>
            <Row>
                <Col span={24}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '12px 16px',
                            border: `1px solid ${propsState.theme === 'light' ? '#0000000f' : '#ffffff1f'}`,
                            borderRadius: 8,
                            gap: 8,
                            backgroundColor: propsState.theme === 'light' ? '#d7e3ff87' : "rgba(45, 156, 219, 0.18)",
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                            }}
                        >
                            <div
                                style={{
                                    width: 36,
                                    height: 36,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#2d9cdb',
                                    borderRadius: 8
                                }}
                            >
                                <FaCalculator
                                    size={18}
                                    color={"#FFFFFF"}
                                />
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <Typography.Text style={{ fontSize: 12 }}>
                                    {'Sistema contábil'}
                                </Typography.Text>

                                <Typography.Text strong style={{ marginTop: -4 }}>
                                    {solicitacao.sistemaContabil.nome}{solicitacao.sistemaContabil.nome === "Outro" && solicitacao.sistemaContabilOutro ? ` - ${solicitacao.sistemaContabilOutro}` : ''}
                                </Typography.Text>
                            </div>
                        </div>

                        <Button
                            type="default"
                            size="small"
                            style={{ borderRadius: 4, background: propsState.theme === 'light' ? '#FFFFFF' : '#141414' }}
                            onClick={onClickEditarSistemaContabil}
                        >
                            Alterar sistema
                        </Button>
                    </div>
                </Col>
            </Row>

            <Modal
                title="Alterar sistema contábil"
                open={modalDesvincularUserVisible}
                destroyOnClose
                width={600}
                onOk={onClickSave}
                onCancel={clickCancelModalAddConfig}
                footer={[
                    <Button
                        key="back"
                        disabled={isSubmiting || loadingTableModal}
                        onClick={clickCancelModalAddConfig}
                    >
                        Cancelar
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={isSubmiting}
                        disabled={isSubmiting || loadingTableModal}
                        onClick={onClickSave}
                    >
                        Salvar
                    </Button>,
                ]}
            >
                {
                    dadosTabelaUsuariosModal && (
                        <div
                            style={{
                                marginBottom: 15
                            }}
                        >
                            <CardInformacao
                                IconComponent={FaRegFileAlt}
                                title="CONTRATO"
                                value={dadosTabelaUsuariosModal?.nome || "--"}
                            />
                        </div>
                    )
                }

                <Table
                    rowKey={(record) => record.id}
                    loading={loadingTableModal}
                    rowClassName={(record, index) => "ativoList"}
                    rowSelection={{ type: 'radio', ...rowSelectionModal }}
                    columns={columnsModal} dataSource={dadosTabelaUsuariosModal?.sistemas || []}
                    scroll={{ y: 200 }}
                    onChange={
                        (pagination, filters, sorter, extra) => {
                            refContagemDoFiltroTabelaModal.current = extra.currentDataSource
                        }
                    }
                    title={(registrosTabela) => {
                        return (
                            <div
                                style={{
                                    backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                    padding: 10,
                                    margin: -8,
                                    marginBottom: 0.5
                                }}
                            >
                                {
                                    dadosTabelaUsuariosModal?.sistemas?.length !== undefined && (
                                        <Typography.Text>
                                            {`Mostrando: ${registrosTabela.length} de ${refContagemDoFiltroTabelaModal.current.length === 0 ?
                                                dadosTabelaUsuariosModal?.sistemas?.length :
                                                refContagemDoFiltroTabelaModal.current.length} num total de ${dadosTabelaUsuariosModal?.sistemas?.length} `}
                                        </Typography.Text>
                                    )
                                }
                            </div>
                        )
                    }}
                    size="small"
                    pagination={{ locale: { items_per_page: '' } }}
                    locale={locale.Table}
                />
            </Modal>
        </>
    )
}
